if (!customElements.get('breadcrumbs-placeholder')) {
    // console.log('breadcrum code load start');
    class BreadcrumbsPlaceholder extends HTMLElement {
        connectedCallback() {
            let lastCollectionName = sessionStorage.getItem('lastCollectionName');
            let lastCollectionHandle = sessionStorage.getItem('lastCollectionHandle');
            const productCollections = window.productCollectionHandles || [];
            // console.log('productCollections', productCollections);
            // ❌ If stored collection does NOT belong to this product → discard it
            if ( lastCollectionHandle && !productCollections.includes(lastCollectionHandle)) {
                lastCollectionName = null;
                lastCollectionHandle = null;
            }
            // console.log('lastCollectionName : ', lastCollectionName);
            // console.log('productCollections length : ', productCollections.length);
            // ✅ Fallback to product's own collection
            if (!lastCollectionName && productCollections.length > 0) {
                lastCollectionName = defaultlastCollectionName;
                lastCollectionHandle = defaultlastCollectionHandle;
            }

            const productTitle = defaultproductTitle;
            const slicedTitle = window.innerWidth <= 786 ? productTitle.slice(0, 18) : productTitle.slice(0, 30);

            let breadcrumbHTML = `
                <nav aria-label="Breadcrumb">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="/">Home</a></li>
                `;

            if (lastCollectionName && lastCollectionHandle) {
                breadcrumbHTML += `
            <li class="breadcrumb-item">
              <a href="/collections/${lastCollectionHandle}">
                ${lastCollectionName}
              </a>
            </li>
          `;
            }

            breadcrumbHTML += `
              <li class="breadcrumb-item active" aria-current="page">
                ${slicedTitle}...
              </li>
            </ol>
          </nav>
        `;

            this.innerHTML = breadcrumbHTML;
        }
    }

    customElements.define('breadcrumbs-placeholder', BreadcrumbsPlaceholder);
}